import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getTranscriptionConfig,
  putTranscriptionConfig,
} from "../api/transcriptionConfig";
import type { PutTranscriptionConfigRequest } from "../types/transcription/TranscriptionConfig";

const QUERY_KEY = "transcription-config";

export function useTranscriptionConfig(customerId: string | undefined) {
  return useQuery({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => getTranscriptionConfig(customerId!),
    enabled: !!customerId,
  });
}

export function useUpdateTranscriptionConfig(customerId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: PutTranscriptionConfigRequest) =>
      putTranscriptionConfig(customerId!, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY, customerId] });
    },
  });
}
